import React, { useState, useCallback, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { deleteProduct } from '../../../../store/products/products.api';
import DeleteProductModal from '../modals/delete/delete-product-modal';
import { useProductContext } from '../../products/product-context';
import messages from '../../messages';
import Global from '../../../../store/global-selectors';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

export const DeleteButton = () => {
  const { selectedProductIds, setSelectedProductIds, refreshGridData } = useProductContext();
  const products = useSelector((state) =>
    Global.selectEntitiesProductsByIds(state, {
      productIds: selectedProductIds,
    }),
  );
  const areSomeSelectedIdsActive = products.some((product) => product.active);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openDeleteModal = useCallback(() => setIsModalOpen(true), []);
  const closeDeleteModal = useCallback(() => setIsModalOpen(false), []);

  const cancelablePromiseRef = useRef(null);
  useEffect(() => cancelablePromiseRef.current?.cancel, []);

  const onDelete = useCallback(() => {
    cancelablePromiseRef.current = deleteProduct(selectedProductIds);
    cancelablePromiseRef.current.promise
      .then(() => {
        setIsModalOpen(false);
        setSelectedProductIds([]);
        refreshGridData();
        cancelablePromiseRef.current = null;
      })
      .catch(() =>
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_ERROR,
          title: <FormattedMessage {...messages.deleteProductErrorTitle} />,
          content: <FormattedMessage {...messages.deleteProductErrorContent} />,
        }),
      );
  }, [setIsModalOpen, selectedProductIds, setSelectedProductIds, refreshGridData]);

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={areSomeSelectedIdsActive || selectedProductIds.length === 0}
        onClick={openDeleteModal}
        theme='tertiary'
      >
        <FormattedMessage {...messages.deleteProductButton} />
      </Button>
      {isModalOpen && <DeleteProductModal onClose={closeDeleteModal} onDelete={onDelete} />}
    </>
  );
};
